var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import { Prop, Watch } from 'vue-property-decorator';
import Component from 'vue-class-component';
import DeliverService from '../../../api/DeliverService';
import CommonService from '../../../api/CommonService';
import ClientService from '../../../api/ClientService';
import HeaderItem from '../../../components/HeaderItem';
var default_1 = (function (_super) {
    __extends(default_1, _super);
    function default_1() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.orderSubTypeOptions = [
            {
                id: 3,
                name: '有单退货',
            },
            {
                id: 4,
                name: '无单退货',
            },
        ];
        _this.loading = false;
        _this.deliveryOrderIdoptions = [];
        _this.outOrganList = [];
        _this.organBusinessList = [];
        _this.shopList = [];
        _this.pickerOptions = {
            disabledDate: function (time) {
                return time.getTime() > Date.now();
            },
        };
        _this.timePickerOptions = {
            disabledDate: function (time) {
                return time.getTime() > Date.now();
            },
        };
        return _this;
    }
    default_1.prototype.watchArriveTime = function (newValue, oldValue) {
        if (newValue && this.formData.order_sub_type === 3) {
            this.timePickerOptions = {
                disabledDate: function (time) {
                    return (time.getTime() > Date.now() ||
                        time.getTime() < new Date(newValue).getTime() - 24 * 60 * 60 * 1000);
                },
            };
        }
    };
    default_1.prototype.watchOrderTime = function (newValue, oldValue) {
        if (newValue && this.formData.order_sub_type === 4) {
            this.formData.expect_arrivedate = '';
            this.pickerOptions = {
                disabledDate: function (time) {
                    return time.getTime() > Date.now() || time.getTime() > new Date(newValue).getTime();
                },
            };
        }
    };
    default_1.prototype.watchOrderSubType = function (newValue, oldValue) {
        if (newValue === 4) {
            this.timePickerOptions = {
                disabledDate: function (time) {
                    return time.getTime() <= 0;
                },
            };
            if (this.handleStatus === 2)
                return;
            this.$emit('resetAll');
            this.getOrganList();
        }
        else {
            this.$emit('resetAll');
        }
    };
    default_1.prototype.watchOrganId = function (newValue, oldValue) {
        if (newValue && this.formData.order_sub_type === 4) {
            if (this.handleStatus === 2)
                return;
            this.$emit('emptyGoods');
            this.formData.supplier_to_business_id = '';
            this.formData.shop_id = '';
            this.getOrganBusiness();
        }
    };
    default_1.prototype.watchBusinessId = function (newValue, oldValue) {
        if (newValue && this.formData.order_sub_type === 4) {
            if (this.handleStatus === 2)
                return;
            this.$emit('emptyGoods');
            this.formData.shop_id = '';
            this.getShopList();
        }
    };
    default_1.prototype.watchShopId = function (newValue, oldValue) {
        var _this = this;
        if (newValue && this.formData.order_sub_type === 4 && this.handleStatus === 1) {
            var index = this.shopList.findIndex(function (item) { return item.shop_id == _this.formData.shop_id; });
            this.formData.shop_name = this.shopList[index].shop_name;
        }
    };
    default_1.prototype.created = function () {
        this.deliverService = DeliverService.getInstance();
        this.commonService = CommonService.getInstance();
        this.clientService = ClientService.getInstance();
    };
    default_1.prototype.getShopList = function () {
        var _this = this;
        this.clientService &&
            this.clientService
                .getSupplierShops({ business_id: this.formData.business_id, supplier_to_business_id: this.formData.supplier_to_business_id, limit: 500 })
                .then(function (res) {
                var data = res.data.data;
                _this.shopList = data || [];
                if (_this.shopList.length) {
                    _this.formData.shop_id = _this.shopList[0].shop_id;
                }
            });
    };
    default_1.prototype.getOrganBusiness = function () {
        var _this = this;
        this.commonService &&
            this.commonService.getOrganBusiness({ organ_id: this.formData.organ_id }).then(function (res) {
                var data = res.data.data;
                _this.organBusinessList = data || [];
            });
    };
    default_1.prototype.getOrganList = function () {
        var _this = this;
        this.commonService &&
            this.commonService.getOrganList().then(function (res) {
                var data = res.data.data;
                _this.outOrganList = data || [];
                if (_this.outOrganList.length) {
                    if (!_this.formData.organ_id)
                        _this.formData.organ_id = _this.outOrganList[0].organ_id;
                }
            });
    };
    default_1.prototype.deliveryOrderMethod = function (query) {
        var _this = this;
        if (query) {
            this.loading = true;
            this.deliverService.getRefundDeliveryList({ keyword: query }).then(function (res) {
                _this.loading = false;
                _this.deliveryOrderIdoptions = res.data.data || [];
            });
        }
        else {
            this.deliveryOrderIdoptions = [];
        }
    };
    __decorate([
        Prop({
            required: true,
            type: Number,
        })
    ], default_1.prototype, "handleStatus", void 0);
    __decorate([
        Prop({
            required: true,
        })
    ], default_1.prototype, "formData", void 0);
    __decorate([
        Watch('formData.expect_arrivedate', { immediate: true })
    ], default_1.prototype, "watchArriveTime", null);
    __decorate([
        Watch('formData.order_time', { immediate: true })
    ], default_1.prototype, "watchOrderTime", null);
    __decorate([
        Watch('formData.order_sub_type')
    ], default_1.prototype, "watchOrderSubType", null);
    __decorate([
        Watch('formData.organ_id')
    ], default_1.prototype, "watchOrganId", null);
    __decorate([
        Watch('formData.supplier_to_business_id')
    ], default_1.prototype, "watchBusinessId", null);
    __decorate([
        Watch('formData.shop_id')
    ], default_1.prototype, "watchShopId", null);
    default_1 = __decorate([
        Component({
            components: {
                HeaderItem: HeaderItem,
            },
        })
    ], default_1);
    return default_1;
}(Vue));
export default default_1;
